import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Payment as PaymentIcon } from '@mui/icons-material';
import PaymentItem from './PaymentItem';

const PaymentHistory = ({ paymentHistory, loading }) => {
  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        py: 8 
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={40} sx={{ color: '#3182ce', mb: 2 }} />
          <Typography variant="body1" sx={{ color: '#718096' }}>
            Loading payment history...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (paymentHistory.length === 0) {
    return (
      <Box sx={{
        textAlign: 'center',
        py: 8,
        bgcolor: '#f7fafc',
        borderRadius: 2,
        border: '2px dashed #e2e8f0'
      }}>
        <PaymentIcon sx={{ fontSize: 48, color: '#a0aec0', mb: 2 }} />
        <Typography variant="h6" sx={{ color: '#4a5568', mb: 1 }}>
          No Payment History
        </Typography>
        <Typography variant="body2" sx={{ color: '#718096' }}>
          Your payment history will appear here once you make your first payment.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {paymentHistory.map((payment, index) => (
        <PaymentItem key={payment.id || payment._id || index} payment={payment} />
      ))}
    </Box>
  );
};

export default PaymentHistory;
